var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34409 0.392947C5.60472 0.0930775 6.0205 -0.051227 6.42904 0.0164363L32.5624 4.34448C32.782 4.38084 32.9851 4.4763 33.1467 4.619L38.8633 9.66841C39.303 10.0569 39.3369 10.6975 38.9402 11.1241L20.1569 31.3216C19.8984 31.5994 19.5032 31.7327 19.1131 31.6738C18.7229 31.6148 18.3937 31.3719 18.2436 31.0322L5.17692 1.45718C5.01943 1.10068 5.08349 0.692816 5.34409 0.392947ZM8.95124 4.43422L18.7084 26.5182L20.5377 13.0523L8.95124 4.43422ZM22.7658 13.5295L20.8958 27.295L35.2335 11.8777L22.7658 13.5295ZM35.5939 9.69608L26.0896 10.9553L32.2674 6.75791L35.5939 9.69608ZM29.5442 5.99048L10.4256 2.82416L21.7773 11.2677L29.5442 5.99048Z",
    fill: "#F7F7F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTron);
export default __webpack_public_path__ + "static/media/tron.472e515f1064a84f199b745419d28aca.svg";
export { ForwardRef as ReactComponent };